import { fulfillmentServiceSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod/v4";

export const getFulfillmentServiceForTeam = {
  name: "getFulfillmentServiceForTeam" as const,
  input: z.object({}),
  output: z.object({ fulfillmentServices: z.array(fulfillmentServiceSchema) }),
};
